/**
 * The app's locale runtime (L1), bound to the build's catalogues (`virtual:brevalt-i18n/locales`, served by the
 * app's i18n plugin): only for apps whose plugin serves that module (the customer app). The console stays
 * English and does not import this.
 *
 * A route group's copy (`app.cases`) is a chunk per locale; its pages call the group's hook (`useCasesCopy`),
 * which adds the active locale's chunk to the instance and suspends the first time it loads. The router starts
 * the load together with the page's own chunk (`preloadRouteNamespace`), so there is no waterfall.
 */
import { useTranslation } from "react-i18next";
import * as loaders from "virtual:brevalt-i18n/locales";
import { activeLocale } from "./locale";
import { createLocaleRuntime } from "./runtime";

export const localeRuntime = createLocaleRuntime(loaders);
export const LOCALES: readonly string[] = loaders.LOCALES;

/** A route group's namespace in the active locale (suspends until it is loaded). */
export function useRouteNamespace(namespace: string): void {
  const { i18n } = useTranslation();
  localeRuntime.usePart(i18n, namespace);
}

/** Starts loading route groups' namespaces of the active locale (fire and forget: the page's hook waits). */
export function preloadRouteNamespace(...namespaces: string[]): void {
  localeRuntime.preload(activeLocale(), ...namespaces).catch(() => undefined);
}
